import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../assets/css/components/course-section-card.css'

const SectionCard = ({ section, courseId }) => {
  return(
    <div className="col-md-6 col-lg-4 col-xl-3 m-b-10 course-section-card">
      <div className="ar-1-1">
        <div className="card no-border bg-primary widget widget-loader-circle-lg no-margin">
          <div className="card-block">
            <div className="card-top pull-top">
              <div className="pull-right">
                <Link title='View this class' to={`/classes/${section.id}/`} className='ab-link'></Link>
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="card-body pull-bottom bottom-left bottom-right padding-25">
              <h3 className="text-white">{section.name}</h3>
              <div className='registration-code'>
                <span className="label font-montserrat">{section.registrationCode}</span>
              </div>
              <p className="text-white hint-text hidden-lg-down">{section.students.length} Students</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionCard
